const { Default, match } = require('@nike/rcf-fp');

const caES = require('./ca-ES');
const csCZ = require('./cs-CZ');
const daDK = require('./da-DK');
const deAT = require('./de-AT');
const deCH = require('./de-CH');
const deDE = require('./de-DE');
const elGR = require('./el-GR');
const enAU = require('./en-AU');
const enCA = require('./en-CA');
const enGB = require('./en-GB');
const enIE = require('./en-IE');
const enIN = require('./en-IN');
const enMY = require('./en-MY');
const enNZ = require('./en-NZ');
const enSG = require('./en-SG');
const enUS = require('./en-US');
const enZA = require('./en-ZA');
const esAR = require('./es-AR');
const esCL = require('./es-CL');
const esES = require('./es-ES');
const esMX = require('./es-MX');
const frBE = require('./fr-BE');
const frCH = require('./fr-CH');
const frFR = require('./fr-FR');
const heIL = require('./he-IL');
const hrHR = require('./hr-HR');
const huHU = require('./hu-HU');
const itCH = require('./it-CH');
const itIT = require('./it-IT');
const jaJP = require('./ja-JP');
const koKR = require('./ko-KR');
const nlBE = require('./nl-BE');
const nlNL = require('./nl-NL');
const nnNO = require('./nn-NO');
const plPL = require('./pl-PL');
const ptPT = require('./pt-PT');
const ruRU = require('./ru-RU');
const svSE = require('./sv-SE');
const thTH = require('./th-TH');
const trTR = require('./tr-TR');
const zhCN = require('./zh-CN');
const zhHans = require('./zh-Hans');
const zhHant = require('./zh-Hant');
const zhHK = require('./zh-HK');
const zhMO = require('./zh-MO');

/**
 * A few locales here are grouped to get the closest translations available,
 * but there will be errors in currency symbols displayed in the EJ view
 * (e.g. Chilean pesos are $ while Spain uses €).
 *
 * Every locale object formats currency in a hardcoded manner,
 * and in the future, we can avoid displaying wrong symbols by decoupling
 * the translations and currency, and formatting prices based on
 * the locale of the store passed in instead.
 */
module.exports = {
  locales: (storeLocale) => match(storeLocale)(
    ['ca-ES', caES],
    ['cs-CZ', csCZ],
    ['da-DK', daDK],
    ['de-AT', deAT],
    ['de-CH', deCH],
    ['de-DE', deDE],
    ['el-GR', elGR],
    ['en-AU', enAU],
    ['en-CA', enCA],
    ['en-GB', enGB],
    ['en-IE', enIE],
    ['en-IN', enIN],
    ['en-MY', enMY],
    ['en-NZ', enNZ],
    ['en-SG', enSG],
    ['en-US', enUS],
    ['en-ZA', enZA],
    ['es-AR', esAR],
    ['es-CL', esCL],
    ['es-ES', esES],
    ['es-MX', esMX],
    [() => ['en-FR', 'fr-BE'].includes(storeLocale), frBE],
    ['fr-CH', frCH],
    ['fr-FR', frFR],
    ['hr-HR', hrHR],
    ['he-IL', heIL],
    ['hu-HU', huHU],
    ['it-CH', itCH],
    ['it-IT', itIT],
    ['ja-JP', jaJP],
    ['nl-BE', nlBE],
    ['nl-NL', nlNL],
    ['nn-NO', nnNO],
    ['ko-KR', koKR],
    ['pl-PL', plPL],
    ['pt-PT', ptPT],
    ['ru-RU', ruRU],
    ['sv-SE', svSE],
    ['th-TH', thTH],
    ['tr-TR', trTR],
    ['zh-CN', zhHans],
    ['zh-CN', zhCN],
    ['zh-TW', zhHant],
    ['zh-HK', zhHK],
    ['zh-MO', zhMO],
    [Default, enUS],
  ),
};
